import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    REVIEW_TYPE_OF_PROVIDER,
    REVIEW_TYPE_OF_CUSTOMER,
    propTypes,
} from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
    Page,
    LayoutSideNavigation,
    LayoutWrapperMain,
    LayoutWrapperSideNav,
    LayoutWrapperTopbar,
    AvatarLarge,
    NamedLink,
    SearchResultsPanel,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import config from '../../config';

import css from './ProfilePage.module.css';
import { withRouter } from 'react-router-dom';
import { parse } from '../../util/urlHelpers';
import IconMessage from '../../components/IconMessage/IconMessage';
import IconPhone from '../../components/IconPhone/iconPhone';
import IconMail from '../../components/IconMail/IconMail';
import IconCompany from '../../components/IconCompany/IconCompany';

export class ProfilePageComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // keep track of which reviews tab to show in desktop viewport
            showReviewsType: REVIEW_TYPE_OF_PROVIDER,
        };

        this.showOfProviderReviews = this.showOfProviderReviews.bind(this);
        this.showOfCustomerReviews = this.showOfCustomerReviews.bind(this);
    }

    showOfProviderReviews() {
        this.setState({
            showReviewsType: REVIEW_TYPE_OF_PROVIDER,
        });
    }

    showOfCustomerReviews() {
        this.setState({
            showReviewsType: REVIEW_TYPE_OF_CUSTOMER,
        });
    }

    render() {
        const {
            scrollingDisabled,
            currentUser,
            user,
            userShowError,
            intl,
            listings,
            pagination,
            location,
        } = this.props;
        const ensuredCurrentUser = ensureCurrentUser(currentUser);
        const profileUser = ensureUser(user);
        const isCurrentUser =
            ensuredCurrentUser.id &&
            profileUser.id &&
            ensuredCurrentUser.id.uuid === profileUser.id.uuid;
        const displayName = profileUser.attributes.profile.displayName;
        const bio = profileUser.attributes.profile.bio;

        const hasBio = !!bio;
        const phoneNumber =
            ensuredCurrentUser.attributes?.profile?.publicData?.phoneNumber;

        const company =
        profileUser?.attributes?.profile?.publicData?.company;
        const editLinkMobile = isCurrentUser ? (
            <NamedLink
                className={css.editLinkMobile}
                name="ProfileSettingsPage">
                <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
        ) : null;

        const editLinkDesktop = isCurrentUser ? (
            <NamedLink
                className={css.editLinkDesktop}
                name="ProfileSettingsPage">
                <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
            </NamedLink>
        ) : null;

        const manageListingsLink = isCurrentUser ? (
            <NamedLink
                className={css.manageListingsLink}
                name="ManageListingsPage">
                <FormattedMessage id="ProfilePage.manageListings" />
            </NamedLink>
        ) : null;

        const viewMessageBtn = isCurrentUser && (
            <NamedLink className={css.viewMessageBtn} name="InboxBasePage">
                <IconMessage className={css.viewMessageIcon} />
                <FormattedMessage id="ProfilePage.viewMessageBtn" />
            </NamedLink>
        );

        const asideContent = (
            <div className={css.asideContent}>
                <AvatarLarge
                    className={css.avatar}
                    user={user}
                    disableProfileLink
                />

                {viewMessageBtn}

                <div className={css.listingsHeadingContainer}>
                    <h1 className={css.mobileHeading}>
                        {displayName ? (
                            <>
                                <span className={css.displayName}>
                                    {displayName}
                                </span>
                            </>
                        ) : null}
                    </h1>
                    {editLinkMobile}
                </div>
            </div>
        );

        const userListings = listings.length ?  (
            <div className={css.listingsContentContainer}>
                <div className={css.listingsHeadingContainer}>
                    <h3 className={css.listingsHeading}>
                        <span className={css.userDisplayName}>
                            {displayName}
                        </span>
                        <FormattedMessage id="ProfilePage.userListingsHeadingTitle" />
                    </h3>
                    {manageListingsLink}
                </div>

                <div className={css.listingsContainer}>
                    <SearchResultsPanel
                        search={parse(location.search)}
                        cardsClassName={css.listingCards}
                        cardClassName={css.listingCard}
                        listings={listings}
                        pagination={pagination}
                    />
                </div>
            </div>
        ) : null;

        const mainContent = (
            <div className={css.desktopHeadingContainer}>
                <div className={css.listingsHeadingContainer}>
                    <h1 className={css.desktopHeading}>
                        {displayName ? (
                            <>
                                <FormattedMessage id="ProfilePage.desktopHeading" />
                                <span className={css.displayName}>
                                    {displayName}
                                </span>
                            </>
                        ) : null}
                    </h1>
                    {editLinkDesktop}
                </div>

                {hasBio ? <p className={css.bio}>{bio}</p> : null}
                <p className={css.protectedInfo}>
                    {isCurrentUser && <div>
                        <IconMail className={css.icon} />
                        {ensuredCurrentUser.attributes.email}
                    </div>}
                    {company && !userListings ?  <div>
                        <IconCompany className={css.icon} />
                        {company}
                    </div>: null}
                    {isCurrentUser && phoneNumber && (
                        <div>
                            <IconPhone className={css.icon} />
                            {phoneNumber}
                        </div>
                    )}
                </p>
              {userListings}
            </div>
        );
        let content;
        if (userShowError && userShowError.status === 404) {
            return <NotFoundPage />;
        } else if (userShowError) {
            content = (
                <p className={css.error}>
                    <FormattedMessage id="ProfilePage.loadingDataFailed" />
                </p>
            );
        } else {
            content = mainContent;
        }

        const schemaTitle = intl.formatMessage(
            {
                id: 'ProfilePage.schemaTitle',
            },
            {
                name: displayName,
                siteTitle: config.siteTitle,
            }
        );

        return (
            <Page
                scrollingDisabled={scrollingDisabled}
                title={schemaTitle}
                schema={{
                    '@context': 'http://schema.org',
                    '@type': 'ProfilePage',
                    name: schemaTitle,
                }}>
                <LayoutSideNavigation>
                    <LayoutWrapperTopbar>
                        <TopbarContainer currentPage="ProfilePage" />
                    </LayoutWrapperTopbar>
                    <LayoutWrapperSideNav className={css.aside}>
                        {asideContent}
                    </LayoutWrapperSideNav>
                    <LayoutWrapperMain>{content}</LayoutWrapperMain>
                </LayoutSideNavigation>
            </Page>
        );
    }
}

ProfilePageComponent.defaultProps = {
    currentUser: null,
    user: null,
    userShowError: null,
    reviews: [],
    queryReviewsError: null,
};

const { bool, arrayOf, number, shape, func, string } = PropTypes;

ProfilePageComponent.propTypes = {
    scrollingDisabled: bool.isRequired,
    currentUser: propTypes.currentUser,
    user: propTypes.user,
    userShowError: propTypes.error,
    reviews: arrayOf(propTypes.review),
    queryReviewsError: propTypes.error,

    // form withViewport
    viewport: shape({
        width: number.isRequired,
        height: number.isRequired,
    }).isRequired,

    // from withRouter
    history: shape({
        push: func.isRequired,
    }).isRequired,
    location: shape({
        search: string.isRequired,
    }).isRequired,

    // from injectIntl
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    const { currentUser } = state.user;
    const {
        userId,
        userShowError,
        reviews,
        queryReviewsError,
        userListingRefs,
        pagination,
    } = state.ProfilePage;
    const userMatches = getMarketplaceEntities(state, [
        { type: 'user', id: userId },
    ]);
    const user = userMatches.length === 1 ? userMatches[0] : null;
    const pageListings = getMarketplaceEntities(state, userListingRefs);

    return {
        listings: pageListings,
        pagination,
        scrollingDisabled: isScrollingDisabled(state),
        currentUser,
        user,
        userShowError,
        reviews,
        queryReviewsError,
    };
};

const ProfilePage = compose(
    withRouter,
    connect(mapStateToProps),
    withViewport,
    injectIntl
)(ProfilePageComponent);

export default ProfilePage;
